module.exports = __webpack_public_path__ + "static/media/placeholder-signature.881def65.svg";